import { render } from "./SideTool.vue?vue&type=template&id=f646d5b4&scoped=true"
import script from "./SideTool.vue?vue&type=script&lang=js"
export * from "./SideTool.vue?vue&type=script&lang=js"

import "./SideTool.vue?vue&type=style&index=0&id=f646d5b4&scoped=true&lang=scss"

import exportComponent from "D:\\work\\CodeV4\\FCP-Web-V4\\leanloop-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f646d5b4"]])

export default __exports__